import { render, staticRenderFns } from "./article0.vue?vue&type=template&id=9aa604bc"
import script from "./article0.vue?vue&type=script&lang=js"
export * from "./article0.vue?vue&type=script&lang=js"
import style0 from "./article0.vue?vue&type=style&index=0&id=9aa604bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports